module.exports = __webpack_public_path__ + "static/img/logoHG.3b2a53ae.jpg";